import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { LogInModal } from 'components/LogInModal';
import { LogOutModal } from 'components/LogOutModal';
import { getText } from 'services/languageService';
import {
  setMainPageLangAction,
  setOpenLoginAction,
} from 'store/actions/mainPage';
import { MainLangType } from 'types/mainPage';
import { LeftMenu } from 'components/LeftMenu';
import { MapBlock } from 'containers/MapBlock';
import { AppHeader } from 'containers/AppHeader';
import { FeedbackModal } from 'components/FeedbackModal';
import { CookieNotification } from 'components/CookieNotification';
import { Box } from '@mui/material';
import { getCookie } from 'utils/cookie';
import { httpClient } from 'utils/httpClient';
import ReactGA from 'react-ga';

const URL = process.env.REACT_APP_API_URL;
const GA_TRACKING_ID = process.env.REACT_APP_GA_ID || '';

ReactGA.initialize(GA_TRACKING_ID);

export const MainPage = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { lang, isOpenLogin } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();
  const toggleDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const lsLang = localStorage.getItem('lang');
    const isAuth = getCookie('user');

    if (!isAuth) {
      const url = `${URL}/api/openmap`;
      httpClient.post(url);
    }
    if (lsLang !== lang && lsLang) {
      dispatch(setMainPageLangAction(lsLang as MainLangType));
    }

    ReactGA.pageview(window.location.pathname + window.location.search); //Google Analytics
  }, []);

  useEffect(() => {
    document.title = getText('PAGE_TITLE');
  }, [lang]);

  const closeLogInModal = () => {
    dispatch(setOpenLoginAction(false));
  };

  return (
    <Box>
      <AppHeader toggleDrawer={toggleDrawer} />
      <LeftMenu toggleDrawer={toggleDrawer} open={open} />
      <MapBlock />
      <FeedbackModal />
      <CookieNotification />
      <LogInModal handleClose={closeLogInModal} open={isOpenLogin} />
      <LogOutModal />
    </Box>
  );
};
